import * as angular from "angular";
import {IController} from "angular";

export class PlanningDepotsTableCtrl implements IController {

  depots: any;
  onRemove: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }
}


angular
  .module('bringoz.admin.planning')
  .component('planningDepotsTable', {
    bindings: {
      depots: '<',
      onRemove: '&'
    },
    template: require('./planning-depots-table.html').default,
    controller: PlanningDepotsTableCtrl
  });
